<template>
  <div
    class="filter ais-RefinementList"
    v-if="state"
  >
    <ul class="ais-RefinementList-list">
      <li class="ais-RefinementList-item">
        <label>
          <input
            type="checkbox"
            @click="refineAll"
            value="__all"
            :checked="allChecked"
          />
          <span>all days</span>
        </label>
      </li>
      <li
        class="ais-RefinementList-item"
        v-for="(item, i) in state.items"
        :key="i"
      >
        <label>
          <input
            type="checkbox"
            @click="state.refine(item.value)"
            :value="item.value"
            :checked="item.isRefined"
          />
          <span>{{ item.label }}</span>
        </label>
      </li>
    </ul>
  </div>
</template>

<script>
import { createWidgetMixin } from 'vue-instantsearch';
import { connectRefinementList } from 'instantsearch.js/es/connectors';
import { createPanelConsumerMixin } from '../mixins/panel';
import { daysOfWeek, pureDaysOfWeek } from '../store.js';

const attribute = 'availability.available_day';

export default {
  mixins: [
    createWidgetMixin({ connector: connectRefinementList }),
    createPanelConsumerMixin({
      mapStateToAppliedRefinements: state =>
        state
          ? (state.items || []).filter(
              item => item.isRefined && item.label !== 'today'
            ).length
          : 0,
    }),
  ],
  data() {
    return {
      widgetParams: {
        sortBy(a, b) {
          return daysOfWeek.indexOf(a.name) - daysOfWeek.indexOf(b.name);
        },
        transformItems(items) {
          const currentDay = pureDaysOfWeek[new Date().getDay() - 1];
          const todayDuplicate = items.find(
            item => item.value === currentDay
          ) || {
            isRefined: false,
          };

          const today = {
            ...todayDuplicate,
            label: 'today',
          };

          // TODO: decide if december should be filtered out
          let array = [today, ...items];

          return array;
        },
        operator: 'and',
        attribute,
      },
    };
  },
  computed: {
    helper() {
      return this.state && this.state.instantSearchInstance.helper;
    },
    allChecked() {
      return (
        this.state &&
        !this.state.items
          .filter(item => item.label !== 'December')
          .some(item => !item.isRefined)
      );
    },
  },
  methods: {
    refineAll() {
      if (this.allChecked === false) {
        daysOfWeek.forEach(value => {
          if (value !== 'December') {
            this.helper.addFacetRefinement(attribute, value);
          }
        });
      } else {
        daysOfWeek.forEach(value => {
          if (value !== 'December') {
            this.helper.removeFacetRefinement(attribute, value);
          }
        });
      }
      this.helper.search();
    },
  },
};
</script>

<style scoped>
.ais-RefinementList-item {
  text-transform: capitalize;
}
</style>
